import { Chip, Stack } from '@mui/material';
import {
	InventoryItemAllocationBoolean,
	InventoryItemAllocationQuantity,
	isInventoryItemAllocationBoolean,
	isInventoryItemAllocationQuantity,
} from 'common/modules/inventory';
import React from 'react';
import { useTranslation } from 'services/localization';
import { getInventoryAllocationOptionTranslation } from '../utils';

interface Props {
	value: InventoryItemAllocationBoolean | InventoryItemAllocationQuantity;
}

export const AllocationCell = (props: Props) => {
	const { value } = props;
	const { t } = useTranslation();

	if (isInventoryItemAllocationBoolean(value)) {
		if (value.sales) {
			return (
				<Chip
					size="small"
					variant="outlined"
					label={getInventoryAllocationOptionTranslation(t, 'sales')}
				/>
			);
		}
		if (value.rental) {
			return (
				<Chip
					size="small"
					variant="outlined"
					label={getInventoryAllocationOptionTranslation(t, 'rental')}
				/>
			);
		}
	}

	if (isInventoryItemAllocationQuantity(value)) {
		const { sales = 0, rental = 0 } = value;

		return (
			<Stack direction="row" spacing={1}>
				{rental > 0 && (
					<Chip
						size="small"
						variant="outlined"
						label={`${getInventoryAllocationOptionTranslation(t, 'rental')}: ${rental}`}
						sx={{ minWidth: 40 }}
					/>
				)}
				{sales > 0 && (
					<Chip
						size="small"
						variant="outlined"
						label={`${getInventoryAllocationOptionTranslation(t, 'sales')}: ${sales}`}
						sx={{ minWidth: 40 }}
					/>
				)}
			</Stack>
		);
	}

	return null;
};
